import { createContext } from "react";
import emptyFunction from "fbjs/lib/emptyFunction";

export const X1DarkModeContext = createContext({
  onDarkModeToggle: emptyFunction,
});
